<template>
  <div
      class="bb-tracking-table-row-toggle-cell"
      @click.stop
    >
    <span
      :ref="'toggle-cell' + item.id"
      @click.stop="changeToggleValue"
    >
          <toggle
            :name="item.name"
            :value="item.value"
            :disabled="true"
            type="accent-small"
          />
    </span>
    <transition name="bounce">
      <div
        v-if="isShowModalInfo"
        class="bb-tracking-table-row-toggle-cell__modal"
        :style="modalStyle"
        @click.stop
      >
        <div class="bb-tracking-table-row-toggle-cell__text">
          {{ item.value ? item.textAttentionForSetFalse : item.textAttentionForSetTrue }}
        </div>
        <div class="bb-tracking-table-row-toggle-cell__btns">
          <button @click="save(item)">Yes</button>
          <button @click.prevent="close">No</button>
        </div>
      </div>
    </transition>
    <div v-if="isShowModalInfo" class="bg-fake" @click.stop="close" />
    </div>
</template>

<script>
import toggle from '@/components/Main/Inputs/toggle'

export default {
  name: "ToggleCellTrackingTable",
  props: ['item'],
  components: {
    toggle,
  },
  data () {
    return {
      isShowModalInfo: false,
      modalStyle: null,
    }
  },
  methods: {
    changeToggleValue() {
      this.isShowModalInfo = !this.isShowModalInfo;
      const element = this.$refs['toggle-cell' + this.item.id];
      const { left, bottom } = element.getBoundingClientRect();
      this.modalStyle = {
        left: `${ left }px`,
        top: `${ bottom + 10 }px`
      }
    },
    save(data) {
      this.$emit('changeToggle',  !data.value);
      this.isShowModalInfo = false;
    },
    close () {
      this.isShowModalInfo = false;
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/variables";

.bb-tracking-table-row-toggle-cell {
  width: 100%;
  height: 100%;
  cursor: initial;

  &__modal {
    position: fixed;
    z-index: 99;
    width: 170px;
    padding: 14px;
    border-radius: 5px;
    box-shadow: 0 0 20px rgba($color-black, 0.05);
    text-align: center;
    color: $color-black;
    background-color: $color-white;
  }

  &__text {
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    margin-bottom: 13px;
  }

  &__btns {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 10px;

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $color-denim;
      color: $color-white;
      border-radius: 5px;
      width: 40px;
      height: 26px;
      cursor: pointer;
      transition: background-color 0.3s ease-in;

      &:hover {
        background-color: rgba($color-denim, 0.78);
      }
    }
  }
}

.bg-fake {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 98;
  cursor: initial;
}

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingTable/ToggleCellTrackingTable/ToggleCellTrackingTable.vue